/** Supervisor wallboard (M29 Phase 2): tiles and the agent board. Shell created by WP-M29-SCHEMA2: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const wallboard = {
  tiles: {
    group: "Live figures",
    queue: "In queue",
    queueHint: "Chats waiting for a person",
    breakdownTeams: "By team",
    breakdownTiers: "By tier",
    noTeam: "No team",
    noTier: "No tier",
    longestWait: "Longest wait",
    longestWaitNone: "Nobody is waiting",
    priorityWaiting: "Priority waiting",
    priorityWaitingHint: "High or urgent chats nobody holds yet",
    agentsOnline: "Agents online",
    agentsOnlineHint: "Online, out of everyone who can take chats",
    atLimit: "At chat limit",
    atLimitHint: "Agents holding as many chats as their limit allows",
    slasAtRisk: "SLAs at risk",
    slasAtRiskHint: "Late, or due within {{minutes}} minutes",
    safetyCases: "Safety cases open",
    safetyCasesHint: "Required handovers that outrank every tier, waiting or held",
    needsAttention: "Needs attention",
  },
  board: {
    title: "Wallboard",
    subtitle: "The queue and your agents, live.",
    live: "Live",
    liveUpdated: "Live, updated {{seconds}} s ago",
    polling: "Refreshing every {{seconds}} s",
    connecting: "Connecting",
    reconnecting: "Reconnecting, refreshing every {{seconds}} s",
    stale: "Last update {{seconds}} s ago",
    loading: "Loading the wallboard",
    errorTitle: "The wallboard could not load",
    errorBody: "We could not read the live figures. Check your connection and try again.",
    retry: "Try again",
    offTitle: "Live chat operations is not switched on",
    offBody: "The wallboard shows the queue and your agents once live chat operations is switched on for this workspace. Ask the platform owner to turn it on.",
    offAction: "Back to the inbox",
    agents: {
      title: "Agents now",
      subtitle: "Load against each person's limit.",
      tableLabel: "Agents and their load",
      agent: "Agent",
      status: "Status",
      load: "Load",
      longest: "Longest chat",
      actions: "Actions",
      loadText: "{{active}} of {{limit}}",
      loadLabel: "{{name}}: {{active}} of {{limit}} chats",
      atLimit: "At limit",
      none: "None",
      emptyTitle: "No agents to show yet",
      emptyBody: "People whose role can reply to chats appear here with their status and the chats they hold.",
      emptyAction: "Open the team",
      teams: "Teams: {{teams}}",
    },
    waiting: {
      title: "Waiting now",
      subtitle: "Safety cases first, then by priority and wait.",
      listLabel: "Chats waiting for a person",
      waited: "waiting {{time}}",
      more: "{{count}} more waiting",
      safety: "Safety case",
      priorityUrgent: "Urgent",
      priorityHigh: "High",
      emptyTitle: "Nobody is waiting",
      emptyBody: "Chats that ask for a person show here until an agent takes them.",
      untitled: "Chat",
      assign: "Assign",
      assignLabel: "Assign the chat \"{{title}}\"",
    },
    reassign: {
      button: "Reassign",
      buttonLabel: "Reassign a chat held by {{name}}",
      title: "Move a chat to",
      forChat: "Chat: {{title}}",
      pickChat: "Pick a chat of {{name}}",
      noChats: "{{name}} holds no chats you can see.",
      chatHeld: "held {{time}}",
      noRoom: "At limit",
      offline: "Offline",
      you: "You",
      noTargets: "Nobody else can take it right now.",
      done: "Moved to {{name}}",
      alreadyThere: "{{name}} already holds this chat",
      failed: "The chat was not moved",
      full: "{{name}} is at their chat limit",
      gone: "That chat is no longer waiting or held",
    },
    status: {
      autoAway: "Away (inactive)",
    },
  },
} as const;
